import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";
import { IStatusHistory, TStatusHistoryEntityType } from "../../../types/api/statusHistory";

export async function listStatusHistory(params: {
  entity_type: TStatusHistoryEntityType;
  entity_id: number;
}): Promise<AxiosResponse<TResponse<IStatusHistory[]>>> {
  return axios.get(API_ENDPOINTS.STATUS_HISTORY_LIST, { params });
}
